import {TableContainer, TableBody, TableHead, TableRow, Checkbox, Paper, Table, TableCell} from '@mui/material';
import React, {Fragment, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {getShortSpecName, getCityName} from './Trans.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import ObsAppBar from './AppBar.js';
import {COMM_OK} from './WsR2.js';
import {dStr} from './Util.js';

const NotificationList = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	useEffect(() => {
		loadNotificationList();
		// eslint-disable-next-line
	}, []);

	const getheader = () => t('menu.notification_list');

	function notificationListRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('notificationListRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'notify') {
			if (msg.op === 'list') {
				if (msg.result === 'OK') {
// 					console.log('notificationListRxWs', msg);
					gStorage.notify.setNList(msg.data.notifylist);
				} else {
					console.error('notificationListRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else if (msg.op === 'tgl_seen') {
				if (msg.result === 'OK') {
					loadNotificationList();
				} else {
					console.error('notificationListRxWs:', msg.cmd, msg.op, 'failed!');
				}	
			} else {
				console.error('notificationListRxWs: unknown operation', msg.cmd, msg.op, msg.result);
			}
		} else {
			console.error('notificationListRxWs: invalid command', msg.cmd, msg.op);
		}
	}

	function loadNotificationList() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'notify',
			op: 'list',
			data: {
				user: gStorage.conn.user,
				count: 50,
				pos: 0
			}
		};

		gStorage.conn.ws.send(msg, notificationListRxWs);
	}

	function nSeenCheck(n) {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'notify',
			op: 'tgl_seen',
			data: {
				user: gStorage.conn.user,
				notification: n				
			}
		};

// 		console.log('nSeenCheck', msg);
		gStorage.conn.ws.send(msg, notificationListRxWs);
	}

	function notificationSpecName(spec_id) {
		const spec = gStorage.lists.speclist.list.find(s => s.id === spec_id);
		return getShortSpecName(spec, gStorage.conn.user);
	}

	function notificationUser(user_id) {
		const user = gStorage.lists.userlist.list.find(u => u.id === user_id);

		let u_name = user.first_name;
		if (u_name.length) {
			if (user.last_name.length) {
				u_name += ' ';
				u_name += user.last_name;
			}
		} else {
			u_name = user.last_name;
		}

		if (!u_name.length)
			u_name = user.nick;

		return u_name;
	}

	function notificationCity(city_id) {
		const city = gStorage.lists.citylist.list.find(c => c.id === city_id);
		return getCityName(city, gStorage.conn.user);
	}

	return (
		<Fragment>
			<ObsAppBar getheader={getheader}/>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell padding='checkbox'>#</TableCell>
							<TableCell>{t('notify.species')}</TableCell>
							<TableCell>{t('notify.time')}</TableCell>
							<TableCell>{t('notify.address')}</TableCell>
							<TableCell>{t('notify.observer')}</TableCell>
							<TableCell >{t('notify.notification')}</TableCell>
							<TableCell align='center'>{t('notify.seen')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{gStorage.notify.nlist.map((n, ind) => {
								return (
									<TableRow key={n.chain_id}>
										<TableCell padding='checkbox'>{n.id}</TableCell>
										<TableCell>{notificationSpecName(n.spec_id)}</TableCell>
										<TableCell>{dStr(n.start_t)}</TableCell>
										<TableCell>{notificationCity(n.city_id) + ', ' + n.addr}</TableCell>
										<TableCell>{notificationUser(n.user_id)}</TableCell>
										<TableCell>{n.chain}</TableCell>
										<TableCell align='center'>
											<Checkbox style={{margin:0, padding:6}}
												indeterminate={false}
												checked={!!n.seen}
												onChange={nSeenCheck.bind(this, n)}
												color={'primary'}
												disabled={!gStorage.conn.online}
											/>
										</TableCell>
									</TableRow>
								);
							})
						}
					</TableBody>
				</Table>
			</TableContainer>
		</Fragment>
	);
});

export default NotificationList;
